import React, { useMemo } from 'react';

/**
 * Обвивката на `Icons.jsx`, но без каталога — пътищата се подават отвън.
 *
 * ЗА КАКВО Е: няколко компонента в критичния път (`Toast`, `Footer`) ползват по 1–4 икони.
 * Импортът на `Icons.jsx` заради тях вкарваше целия генериран каталог в layout и page
 * chunk-овете. Тук иконите живеят до компонента, който ги ползва, и нищо не се влачи.
 *
 * Структурата (div + svg + stroke атрибути) повтаря `Icons.jsx` едно към едно нарочно —
 * така вграждането не променя нито един пиксел.
 */
const STROKE_ATTRS = {
  strokeLinejoin: 'round',
  strokeLinecap: 'round',
  strokeMiterlimit: '4',
  strokeWidth: 64,
};

const InlineIcon = ({ paths, size = 24, color = 'currentColor', className = '' }) => {
  const containerStyle = useMemo(
    () => ({
      width: size,
      height: size,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
    [size],
  );

  return (
    <div className={className} style={containerStyle}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 1024 1024"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
      >
        {paths.map((d, i) => (
          <path key={i} d={d} stroke={color} fill="none" {...STROKE_ATTRS} />
        ))}
      </svg>
    </div>
  );
};

export default React.memo(InlineIcon);
